module.exports = __webpack_public_path__ + "static/img/evm_banner.72c557e4.jpg";